<template>
<div class="body_flow page">
    <div v-if="isSubmitting" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <!-- BMI Too Low Modal -->
    <div v-if="showBMITooLowModal" class="modal-overlay" @click="closeBMITooLowModal">
        <div class="modal-content bmi-too-low-modal" @click.stop>
            <div class="intro-modal-body">
                <div v-if="!showRefundMessage">
                    <div class="intro-modal-heading">
                        <strong>Your BMI is too low to qualify for this program</strong>
                    </div>
                    <div class="modal-message">
                        Based on the information you provided, your current BMI does not meet the minimum requirement for this weight loss program.
                    </div>
                    <div class="modal-buttons">
                        <button class="modal-primary-button" @click="editWeightAndHeight">Edit Weight & Height</button>
                        <button class="modal-secondary-button" @click="handleBMIDisqualification">OK, I Understand</button>
                    </div>
                </div>
                <div v-else>
                    <div class="intro-modal-heading">
                        <strong>Refund Processed</strong>
                    </div>
                    <div class="modal-message">
                        We have refunded the amount authorized on your card. This will reflect on your statement in 3-5 business days.
                    </div>
                    <button class="modal-close-button" @click="closeBMITooLowModal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="100vw" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el>3">
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651" style="margin-bottom: 3px;"></a>
                </div>
                <div class="mobile-nav-links">
                    <a :href="supportPhoneTel" class="link-block-109 w-inline-block"><img src="@/assets/images/icon_call_1.svg" loading="lazy" alt="" class="image-692"></a>
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()" v-if="active_el>3"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress" :style="{ width: Math.round((active_el / (totalSteps+1)) * 100) + '%' }"></div>
            </div>
        </div>
    </section>
    <section class="section-fixed-controlnav hide-block">
        <div class="flow-ctrl-nav-wrap">
            <div class="ctrl-div">
                <div class="ctrl-div-flex">
                    <a href="#" class="continue-button w-button">Continue</a>
                </div>
            </div>
        </div>
    </section>
    <section class="section_checkout-flow">
        <div class="flow_wrap">

            <div class="step_forminfo_div" v-if="active_el === 1">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Tell us about yourself</div>
                    <div class="text-block-1686">Helps confirm you qualify for program.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="b6f9984d-e516-2288-ed34-749c02b56425" @submit.prevent="handleSubmit">

                            <div class="form-field-label">Sex assigned at birth*</div>
                            <div class="selectwrap">
                                <span class="select-icon" aria-hidden="true"> <svg viewBox="0 0 16 16" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0 text-secondary-400" aria-hidden="true" width="18" height="18">
                                        <path d="M3.47845 6.89783C3.47845 4.95347 5.05467 3.37725 6.99903 3.37725C8.94339 3.37725 10.5196 4.95347 10.5196 6.89783C10.5196 8.84217 8.94328 10.4184 6.99889 10.4184C5.05456 10.4184 3.47845 8.84222 3.47845 6.89783ZM6.99903 2.19631C4.40245 2.19631 2.29751 4.30125 2.29751 6.89783C2.29751 9.29443 4.09049 11.2721 6.40843 11.5626V12.5533H5.53082C5.20471 12.5533 4.94035 12.8177 4.94035 13.1438C4.94035 13.4699 5.20471 13.7342 5.53082 13.7342H6.40847L6.40858 15.1993C6.4086 15.5255 6.67299 15.7898 6.99909 15.7898C7.3252 15.7897 7.58954 15.5254 7.58952 15.1993L7.58941 13.7342H8.46728C8.79339 13.7342 9.05775 13.4699 9.05775 13.1438C9.05775 12.8177 8.79339 12.5533 8.46728 12.5533H7.58936V11.5626C9.90729 11.2721 11.7005 9.29447 11.7005 6.89783C11.7005 4.30125 9.59561 2.19631 6.99903 2.19631Z">
                                        </path>
                                        <path fill-rule="evenodd" d="M10.2124 0.745546C10.2124 0.532708 10.385 0.360168 10.5978 0.360168H13.167C13.3798 0.360168 13.5524 0.532708 13.5524 0.745546V3.31473C13.5524 3.52757 13.3798 3.70011 13.167 3.70011C12.9542 3.70011 12.7816 3.52757 12.7816 3.31473V1.67593L10.441 4.01652C11.1 4.7987 11.497 5.80878 11.497 6.91159C11.497 9.3947 9.48407 11.4077 7.00096 11.4077C4.51784 11.4077 2.50488 9.3947 2.50488 6.91159C2.50488 4.42848 4.51784 2.41552 7.00096 2.41552C8.10377 2.41552 9.11384 2.81257 9.89603 3.47151L12.2366 1.13092H10.5978C10.385 1.13092 10.2124 0.958384 10.2124 0.745546ZM7.00096 3.18627C4.94352 3.18627 3.27564 4.85415 3.27564 6.91159C3.27564 8.96902 4.94352 10.6369 7.00096 10.6369C9.05839 10.6369 10.7263 8.96902 10.7263 6.91159C10.7263 4.85415 9.05839 3.18627 7.00096 3.18627Z">
                                        </path>
                                    </svg>
                                </span>
                                <select id="field-2" name="field-2" data-name="Field 2" class="checkout-flow-dropdown w-select" v-model="people.gender" :class="{ 'field-error': fieldErrors.gender }">
                                    <option value="">Select an option...</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>
                            <div class="form-field-label">Date of birth*</div>
                            <div class="flex-input-div dob">
                                <div class="selectwrap">
                                    <span class="select-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0" aria-hidden="true" width="18" height="18">
                                            <path d="M17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14Z">
                                            </path>
                                            <path d="M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z">
                                            </path>
                                            <path d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z">
                                            </path>
                                            <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z">
                                            </path>
                                            <path d="M7 14C7.55229 14 8 13.5523 8 13C8 12.4477 7.55229 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14Z">
                                            </path>
                                            <path d="M7 18C7.55229 18 8 17.5523 8 17C8 16.4477 7.55229 16 7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18Z">
                                            </path>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.75C7.41421 1.75 7.75 2.08579 7.75 2.5V3.26272C8.412 3.24999 9.14133 3.24999 9.94346 3.25H14.0564C14.8586 3.24999 15.588 3.24999 16.25 3.26272V2.5C16.25 2.08579 16.5858 1.75 17 1.75C17.4142 1.75 17.75 2.08579 17.75 2.5V3.32709C18.0099 3.34691 18.2561 3.37182 18.489 3.40313C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33855 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V14.0564C22.75 15.8941 22.75 17.3498 22.5969 18.489C22.4392 19.6614 22.1071 20.6104 21.3588 21.3588C20.6104 22.1071 19.6614 22.4392 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0565 22.75H9.94359C8.10585 22.75 6.65018 22.75 5.51098 22.5969C4.33856 22.4392 3.38961 22.1071 2.64124 21.3588C1.89288 20.6104 1.56076 19.6614 1.40314 18.489C1.24997 17.3498 1.24998 15.8942 1.25 14.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33855 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40313C5.7439 3.37182 5.99006 3.34691 6.25 3.32709V2.5C6.25 2.08579 6.58579 1.75 7 1.75ZM5.71085 4.88976C4.70476 5.02502 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02502 6.70476 2.88976 7.71085C2.86685 7.88123 2.8477 8.06061 2.83168 8.25H21.1683C21.1523 8.06061 21.1331 7.88124 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02502 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976ZM2.75 12C2.75 11.146 2.75032 10.4027 2.76309 9.75H21.2369C21.2497 10.4027 21.25 11.146 21.25 12V14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25H10C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14V12Z">
                                            </path>
                                        </svg></span>
                                    <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="birth-month" data-name="birth month" placeholder="MM" type="text" id="birth-month" required="" v-model="people.dob.mm" @input="filterNumericInput($event, 12); autoAdvanceDobField('birth-month', 'birth-day', 2)" :class="{ 'field-error': fieldErrors.dob_mm }">
                                </div>
                                <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="birth-day" data-name="birth day" placeholder="DD" type="text" id="birth-day" required="" v-model="people.dob.dd" @input="filterNumericInput($event, 31); autoAdvanceDobField('birth-day', 'birth-year', 2)" :class="{ 'field-error': fieldErrors.dob_dd }">
                                <input class="checkout-flow-input thirds w-input" maxlength="4" pattern="[0-9]*" inputmode="numeric" name="birth-year" data-name="birth year" placeholder="YYYY" type="text" id="birth-year" required="" v-model="people.dob.yyyy" @input="filterNumericInput($event)" :class="{ 'field-error': fieldErrors.dob_yyyy }">
                            </div>
                            <div class="flex-input-div">
                                <div class="flow-form-half-div">
                                    <div class="form-field-label">Height* (Feet)</div>
                                    <input class="checkout-flow-input w-input" maxlength="1" name="height-feet" data-name="height feet" placeholder="eg. 5" pattern="[0-9]*" inputmode="numeric" type="text" id="height-feet" required="" v-model="people.height.foot" @input="filterNumericInput($event, 8)" :class="{ 'field-error': fieldErrors.height_foot }">
                                </div>
                                <div class="flow-form-half-div">
                                    <div class="form-field-label">Height* (Inches)</div><input class="checkout-flow-input w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="height-inches" data-name="height inches" placeholder="eg. 3" type="text" id="height-inches" required="" v-model="people.height.inches" @input="filterNumericInput($event, 11)" :class="{ 'field-error': fieldErrors.height_inches }">
                                </div>
                            </div>
                            <div class="form-field-label">Weight* (Pounds)</div><input class="checkout-flow-input w-input" maxlength="3" pattern="[0-9]*" inputmode="numeric" name="Weight-pounds" data-name="Weight pounds" placeholder="eg. 200" type="text" id="Weight-pounds" required="" v-model="people.weight" @input="filterNumericInput($event)" :class="{ 'field-error': fieldErrors.weight }">

                            <div class="bmi-div" v-if="bmi_calculated"><img src="@/assets/images/icon_info.svg" loading="lazy" alt="" class="image-686">
                                <div class="bmi-text">Your BMI Score is {{ bmi_calculated }}</div>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="flow-ctrls-div first">
                    <a href="#" class="continue-button step first w-button" @click.prevent="handleSubmit">Continue <span class="text-span-423">-&gt;</span></a>
                </div>
            </div>

            <div class="step2_div" v-if="active_el === 2">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Are you currently taking GLP-1 <br>weight loss medication?</div>
                    <div class="text-block-1686">Your healthcare practicioner will review your treatment with you before it&#x27;s finalized.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step2-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="b0df69af-2220-9339-0106-f7d4cfd1434a">
                            <div class="flow_choicesdiv">
                                <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : isTakingGLP1 === true}" @click.prevent="handleGLP1Selection(true)">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : isTakingGLP1 === true}"></div><input type="radio" name="checkbox-glp1" id="checkbox-glp1-yes" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-glp1-yes"><strong>Yes</strong>, I&#x27;m currently taking GLP-1 medication<br></span>
                                </label>
                                <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : isTakingGLP1 === false}" @click.prevent="handleGLP1Selection(false)">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : isTakingGLP1 === false}"></div><input type="radio" name="checkbox-glp1" id="checkbox-glp1-no" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-glp1-no"><strong>No</strong>, but I would like to start<br></span>
                                </label>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step_forminfo_div" v-if="active_el === 3">
                <!-- Loading Overlay -->
               
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers line-break">Enter your details to save your progress</div>

                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" @submit.prevent="handleSubmit">
                            <div class="doc-bar-div"><img src="@/assets/images/Doctor_newself.webp" loading="lazy" sizes="(max-width: 767px) 100vw, 755.0000610351562px" srcset="@/assets/images/Doctor_newself-p-500.webp 500w, @/assets/images/Doctor_newself.webp 755w" alt="" class="image-687">
                                <div>
                                    <div class="text-block-1721">A doctor will prescribe your medication in less than 24 hours.</div>
                                </div>
                            </div>
                            <div class="flow-payment-div">
                                <div class="form-field-label">Phone Number*</div>
                                <input class="checkout-flow-input w-input" maxlength="16" data-name="phone" placeholder="(XXX) XXX-XXXX" type="text" pattern="[0-9()\s-]*" required autocomplete="off" inputmode="numeric" v-model="phoneDisplay" @input="handlePhoneInput" :class="{ 'field-error': fieldErrors.phone }">
                                <div v-if="fieldErrors.phone" class="phone-input-error">Please enter a valid US phone number</div>
                                <div class="sms-consent-row" :class="{ 'sms-consent-shake': smsConsentShake, 'sms-consent-row-error': smsConsentError }">
                                    <input type="checkbox" id="checkbox-sms" name="checkbox-sms" class="sms-consent-checkbox" v-model="people.agree_to_phone" @change="smsConsentError = ''">
                                    <label for="checkbox-sms" class="sms-phone-disclaimer">By checking the box, you agree that NewSelf can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.newself.com/privacy-policy" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Privacy Policy</a> and <a href="https://newself.com/terms-of-use" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Terms</a>.</label>
                                </div>
                            </div>
                            <div class="flow-payment-div">
                                <div class="div-block-2247 phone">
                                    <div v-if="smsConsentError" class="sms-consent-error">{{ smsConsentError }}</div>
                                    <button class="pay-button w-button" @click.prevent="handleSubmit" :disabled="isSubmitting">
                                        <span v-if="isSubmitting">
                                            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1">
                                                    </animateTransform>
                                                </circle>
                                            </svg>
                                        </span>
                                        <span v-else>Save</span></button>
                                </div>
                            </div>

                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import { cleanUsPhone, cleanUsPhoneInput, formatUsPhone, isValidUsPhone } from '@/utils/phone'

export default {
    name: 'WeightLossCheckoutFlow',
    props: ['baseUrl'],
    data() {
        return {
            active_el: 1,
            totalSteps: 2,
            fieldErrors: {},
            smsConsentError: '',
            smsConsentShake: false,
            isSubmitting: false,
            submitted: false,
            isTakingGLP1: null,
            showBMITooLowModal: false,
            showRefundMessage: false,
            people: {
                phone: '',
                agree_to_phone: false,
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                dobMMDDYYYY: 'NA',
                user_agent: "",
                tracking_session_id: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                }
            }
        }
    },
    computed: {
        ...mapGetters(['user']),
        bmi_calculated() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            if (heightInInches && weightInPounds) {
                return ((weightInPounds * 703) / (heightInInches * heightInInches)).toFixed(2);
            }
            return "";
        },
        phoneDisplay: {
            get() {
                // Show an optional "1 " country code, e.g. "1 (555) 555-5555"
                return formatUsPhone(this.people.phone);
            },
            set(value) {
                // Keep an optional leading 1 country code; cap national part at 10
                this.people.phone = cleanUsPhoneInput(value);
            }
        }
    },
    methods: {
        filterNumericInput(event, max) {
            let cleaned = event.target.value.replace(/\D/g, '');
            if (max !== undefined && cleaned !== '' && parseInt(cleaned) > max) {
                cleaned = String(max);
            }
            if (event.target.value !== cleaned) {
                event.target.value = cleaned;
                event.target.dispatchEvent(new Event('input', { bubbles: true }));
            }
        },
        autoAdvanceDobField(currentFieldId, nextFieldId, maxLength) {
            const currentField = document.getElementById(currentFieldId);
            if (currentField && currentField.value.length === maxLength) {
                const nextField = document.getElementById(nextFieldId);
                if (nextField) {
                    nextField.focus();
                }
            }
        },
        handleGLP1Selection(isTaking) {
            this.isTakingGLP1 = isTaking;
            const bmi = parseFloat(this.bmi_calculated);

            if (isNaN(bmi) || bmi <= 0) {
                alert('Please complete the height and weight fields first.');
                return;
            }

            if (!isTaking && bmi < 20) {
                this.showBMITooLowModal = true;
                return;
            }

            // Advance to next step if BMI qualifies
            setTimeout(() => {
                this.active_el++;
            }, 300);
        },
        closeBMITooLowModal() {
            this.showBMITooLowModal = false;
            this.showRefundMessage = false;
        },
        editWeightAndHeight() {
            this.showBMITooLowModal = false;
            this.showRefundMessage = false;
            this.active_el = 1;
            this.isTakingGLP1 = null;
        },
        async handleBMIDisqualification() {
            try {
                this.isSubmitting=true;
                await this.$axios.post(`${this.baseUrl}/api/refund-authorization`, {
                    user_id: this.user?.id,
                    reason: 'BMI too low',
                    height: this.people.heightInInches,
                    weight: this.people.weight,
                    dob: this.people.dobMMDDYYYY,
                    gender: this.people.gender
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                });
                this.isSubmitting=true;
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "We have refunded the amount authorized on your card. This will reflect on your statement in 3-5 business days."
                    }
                });
            } catch (error) {
                this.isSubmitting=true;
                console.error('Refund API error:', error);
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "We have refunded the amount authorized on your card. This will reflect on your statement in 3-5 business days."
                    }
                });
            }
        },
        handlePhoneInput(event) {
            // Cap to 10 digits, then force the displayed value so extra
            // keystrokes can't linger past the cap.
            this.people.phone = cleanUsPhoneInput(event.target.value);
            event.target.value = formatUsPhone(this.people.phone);
            if (this.fieldErrors.phone) this.clearFieldError('phone');
        },
        clearFieldError(field) {
            if (this.fieldErrors[field]) {
                this.$set(this.fieldErrors, field, false);
            }
        },
        setFieldError(field, hasError = true) {
            this.$set(this.fieldErrors, field, hasError);
        },
        GoBack() {
            this.active_el--;
        },
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            if (date > today) {
                return false;
            }

            return true;
        },
        validateStep(step) {
            this.fieldErrors = {};

            if (step === 1) {
                let hasError = false;

                if (!this.people.gender) {
                    this.setFieldError('gender');
                    hasError = true;
                }

                const {
                    mm,
                    dd,
                    yyyy
                } = this.people.dob;

                if (!mm) {
                    this.setFieldError('dob_mm');
                    hasError = true;
                }
                if (!dd) {
                    this.setFieldError('dob_dd');
                    hasError = true;
                }
                if (!yyyy) {
                    this.setFieldError('dob_yyyy');
                    hasError = true;
                }

                if (hasError) {
                    alert('Please complete all required fields');
                    return false;
                }

                if (!this.isValidDate(mm, dd, yyyy)) {
                    this.setFieldError('dob_mm');
                    this.setFieldError('dob_dd');
                    this.setFieldError('dob_yyyy');
                    alert('Please enter a valid date of birth');
                    return false;
                }

                const foot = parseInt(this.people.height.foot);
                const inches = parseInt(this.people.height.inches);
                const weight = parseFloat(this.people.weight);

                if (isNaN(foot) || foot < 4 || foot > 8) {
                    this.setFieldError('height_foot');
                    alert('Please enter a valid height (4-8 feet, 0-11 inches)');
                    return false;
                }

                if (isNaN(inches) || inches < 0 || inches > 11) {
                    this.setFieldError('height_inches');
                    alert('Please enter a valid height (4-8 feet, 0-11 inches)');
                    return false;
                }

                if (isNaN(weight) || weight < 80 || weight > 700) {
                    this.setFieldError('weight');
                    alert('Please enter a valid weight (80-700 pounds)');
                    return false;
                }

                this.people.heightInInches = (foot * 12) + inches;
                this.people.bmi = (weight * 703) / (this.people.heightInInches * this.people.heightInInches);
                this.people.dobMMDDYYYY = `${mm}/${dd}/${yyyy}`;
            }

            return true;
        },
        triggerSmsConsentShake() {
            this.smsConsentShake = false;
            this.$nextTick(() => {
                this.smsConsentShake = true;
                setTimeout(() => {
                    this.smsConsentShake = false;
                }, 700);
            });
        },
        async handleSubmit() {
            if (!this.validateStep(this.active_el)) {
                return;
            }

            if (this.active_el === 3) {
                if (!isValidUsPhone(this.people.phone)) {
                    this.setFieldError('phone');
                    return false;
                }
                if (!this.people.agree_to_phone) {
                    this.smsConsentError = 'Please agree to receive SMS communications to continue';
                    this.triggerSmsConsentShake();
                    return false;
                }
                try {

                    this.people.user_agent = window.navigator.userAgent;
                    const sessionId = window?.trackingSessionId || null;
                    if (sessionId) {
                        this.people.tracking_session_id = sessionId;
                    }

                    const cleanedPhone = cleanUsPhone(this.people.phone);
                    this.isSubmitting = true;

                    const response = await this.$axios.post(`${this.baseUrl}/api/update-user`, {
                        ...this.people,
                        phone: cleanedPhone
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            "Access-Control-Allow-Origin": "*"
                        }
                    });

                    if (response.data.success) {
                        this.$router.push({
                            name: 'upSellPage',
                            query: {
                                amount: response.data.amountCharged,
                                trans_id: response.data.transaction_id,
                                payment_terms: 1
                            }
                        });
                    }
                } catch (error) {
                    console.error('Form submission error:', error);
                    alert('There was an error submitting your form. Please try again.');
                } finally {
                    this.isSubmitting = false;
                }
                return;
            }

            if (this.active_el < this.totalSteps) {
                this.active_el++;
            }
        }
    },
    watch: {
        active_el() {
            this.$nextTick(() => {
                const questionDiv = document.querySelector('.step_forminfo_div');
                if (questionDiv) {
                    const header = document.querySelector('.section-fixed-prognav');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = 20;

                    const elementPosition = questionDiv.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'auto'
                    });
                } else {
                    window.scrollTo(0, 0);
                }
            });
        },
        'people.phone'() {
            this.clearFieldError('phone');
        },
        'people.weight'() {
            this.clearFieldError('weight');
        },
        'people.height.foot'() {
            this.clearFieldError('height_foot');
        },
        'people.height.inches'() {
            this.clearFieldError('height_inches');
        },
        'people.gender'() {
            this.clearFieldError('gender');
        },
        'people.dob.mm'() {
            this.clearFieldError('dob_mm');
        },
        'people.dob.dd'() {
            this.clearFieldError('dob_dd');
        },
        'people.dob.yyyy'() {
            this.clearFieldError('dob_yyyy');
        }
    }
}
</script>

<style scoped>
.checkout_checkbox-selected {
    background-color: var(--light-blue);
}

.page {
    height: 100vh !important;
}

.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.w-input.field-error,
.w-select.field-error {
    border: 2px solid #dc3545 !important;
}

.loading-overlay2 {
    position: fixed;
    inset: 0;
    z-index: 999999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 99999;
}

.modal-content {
    background-color: #fefefe;
    border-radius: 10px;
    max-width: 468px;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.intro-modal-body {
    justify-content: center;
}

.intro-modal-heading {
    font-size: 18px;
    display: flex;
    justify-content: center;
}

.bmi-too-low-modal {
    background-color: #ffffff;
    border-radius: 12px;
    max-width: 520px;
    width: 90%;
    margin: 0 !important;
    padding: 40px 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: none !important;
}

.bmi-too-low-modal .intro-modal-body {
    padding: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.bmi-too-low-modal .intro-modal-heading {
    font-size: 20px;
    line-height: 1.4;
    color: #333;
    margin: 0 0 10px 0;
}

.modal-message {
    font-size: 16px;
    line-height: 1.6;
    color: #666;
    margin-bottom: 10px;
}

.modal-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-top: 10px;
}

.modal-primary-button {
    background-color: #e9ff86;
    color: #000;
    border: none;
    border-radius: 8px;
    padding: 14px 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
}

.modal-primary-button:hover {
    background-color: #d4e76f;
    transform: translateY(-2px);
}

.modal-secondary-button {
    background-color: #f5f5f5;
    color: #333;
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 14px 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
}

.modal-secondary-button:hover {
    background-color: #e8e8e8;
    border-color: #ccc;
    transform: translateY(-2px);
}

.modal-close-button {
    background-color: #e9ff86;
    color: #000;
    border: none;
    border-radius: 8px;
    padding: 12px 40px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.modal-close-button:hover {
    background-color: #d4e76f;
    transform: translateY(-2px);
}

span.select-icon {
    position: absolute;
    top: 15px;
    left: 5px;
}

.selectwrap {
    position: relative;
}

.checkout-flow-input.thirds {
    padding-left: 30px;
}

.checkout-flow-dropdown {
    padding-left: 25px;
}

.selectwrap input#birth-month {
    width: 100%;
}

.checkout-checkbox-text {
    font-size: 16px;
}

@media screen and (max-width: 991px) {
    .section-fixed-prognav {
        position: relative !important;
        z-index: 99999 !important;
        background-color: white !important;
        margin-bottom: 30px !important;
        padding-bottom: 0 !important;
    }

    .section_checkout-flow {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .flow_wrap {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

@media screen and (max-width: 479px) {
    .image-651 {
        width: 16px;
    }

    .bmi-too-low-modal {
        padding: 30px 20px;
    }

    .bmi-too-low-modal .intro-modal-heading {
        font-size: 18px;
    }

    .modal-message {
        font-size: 14px;
    }

    .modal-primary-button,
    .modal-secondary-button {
        font-size: 15px;
        padding: 12px 24px;
    }
}

@media screen and (max-width: 375px) {
    .flex-input-div.dob {
        margin-bottom: 1px;
    }

    .text-block-1686 {
        font-size: 12px;
    }
}

.flow_choicesdiv,
.checkout_checkbox-field {
    pointer-events: auto !important;
}

.sms-phone-disclaimer {
    font-size: 11px;
    line-height: 1.4;
    color: #6b7280;
    margin: -8px 0 16px;
}

.sms-phone-disclaimer-link {
    color: inherit;
    text-decoration: underline;
}

.div-block-2247.phone .enroll-disclaimer-div.form {
    margin-top: 8px;
    margin-bottom: 0;
}

.div-block-2247.phone .enroll-disclaimer-div.form .enroll-checkbox-field.form {
    margin-bottom: 0;
}

@media screen and (max-width: 768px) {
    .sms-phone-disclaimer {
        font-size: 10px;
    }
}

/* SMS consent checkbox (beside disclaimer, above Save button) */
.div-block-2247.phone {
    position: relative;
    margin-top: -4px;
}
.sms-consent-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 8px 0 0;
    padding: 8px 10px;
    border: 1px solid transparent;
    border-radius: 9px;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}
.sms-consent-row .sms-phone-disclaimer {
    margin: 0;
    cursor: pointer;
}
.sms-consent-checkbox {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    margin: 2px 0 0;
    accent-color: #205089;
    cursor: pointer;
}
.sms-consent-row-error {
    border-color: #dc3545;
    background-color: rgba(220, 53, 69, 0.05);
}
.sms-consent-error {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    margin: 0 0 4px;
    color: #dc3545;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
}
.phone-input-error {
    color: #dc3545;
    font-size: 13px;
    margin: 6px 0 0;
    line-height: 1.4;
}
.sms-consent-shake {
    animation: smsConsentShake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
.sms-consent-shake .sms-consent-checkbox {
    animation: smsConsentPulse 0.6s ease both;
}
@keyframes smsConsentShake {
    10%, 90% { transform: translateX(-1px); }
    20%, 80% { transform: translateX(2px); }
    30%, 50%, 70% { transform: translateX(-4px); }
    40%, 60% { transform: translateX(4px); }
}
@keyframes smsConsentPulse {
    0%, 100% { transform: scale(1); }
    30% { transform: scale(1.3); }
    60% { transform: scale(0.95); }
}
</style>
